import { Box } from "@mui/material";
import type { FC } from "react";

import { useAuthentication } from "../../hooks";
import { ReactComponent as PacknetWordArt } from "../../assets/application-word-art/packnet-word-art.svg";
import { ReactComponent as SupportWordArt } from "../../assets/application-word-art/support-word-art.svg";
import { ReactComponent as TenantManagementWordArt } from "../../assets/application-word-art/tenant-management-word-art.svg";
import { ReactComponent as CompanyManagementWordArt } from "../../assets/application-word-art/company-management-word-art.svg";

export const ApplicationWordArt: FC<{ width?: number; height?: number }> = ({ width, height }) => {
	const { applicationName, applicationEnvironment } = useAuthentication();

	const getWordArt = () => {
		if (applicationName === "TenantManagement") {
			return TenantManagementWordArt;
		}

		if (applicationName === "Support") {
			return SupportWordArt;
		}

		if (applicationName === "Company") {
			return CompanyManagementWordArt;
		}

		return PacknetWordArt;
	};

	return (
		<Box
			component={getWordArt()}
			sx={{ filter: applicationEnvironment === "preprod" ? "grayscale(1)" : undefined }}
			width={width}
			height={height}
		/>
	);
};
